@file:OptIn(InternalResourceApi::class)

package acessoescola.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/acessoescola.composeapp.generated.resources/"

@delegate:ResourceContentHash(-310_982_846)
internal val Res.font.myriad_pro_regular: FontResource by lazy {
      FontResource("font:myriad_pro_regular", setOf(
        ResourceItem(setOf(), "${MD}font/myriad_pro_regular.OTF", -1, -1),
      ))
    }

@delegate:ResourceContentHash(557_783_306)
internal val Res.font.source_serif_pro_Regular: FontResource by lazy {
      FontResource("font:source_serif_pro_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/source_serif_pro_Regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("myriad_pro_regular", Res.font.myriad_pro_regular)
  map.put("source_serif_pro_Regular", Res.font.source_serif_pro_Regular)
}
